const apiTMDB = '5ad99ee13849cfaf1fabd5b0e6ccb9c2'; // TMDB
const apiOMDB = '722b64b4'; // OMDB

export default { apiTMDB, apiOMDB };
